import { Component } from '@angular/core';

@Component({
  selector: 'app-interlocutors',
  standalone: true,
  imports: [],
  templateUrl: './interlocutors.component.html',
  styleUrl: './interlocutors.component.scss'
})
export class InterlocutorsComponent {

}
